function PriceCardWrap(props) {
  return (
    <>
      <div className="priceing-plan sec-mar">
        <div className="container">
          <div className="title-wrap">
            <div className={`${"sec-title"}`}>
              <span>¿No sabes por dónde empezar?</span>
              <h2>Asesoría en desarrollo de software e Inteligencia Artificial</h2>
              <p>
                Con una inversión accesible, puedes contar con un <strong>asesor tecnológico</strong> que te guiará en cada 
                paso del proceso de transformación digital de tu empresa. Desde establecer tu presencia en línea con 
                diseño web impactante, hasta <strong>automatizar y optimizar procesos con inteligencia artificial</strong>, 
                nuestro equipo está aquí para 
                ayudarte a crecer. Te ofrecemos un acompañamiento personalizado que garantiza que tu inversión se 
                traduzca en resultados excepcionales y escalables.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PriceCardWrap;